export interface ExpectedPrices {
  /**
   * Expected average EPEX price for the next 12 calendar months, weighted by the E1B
   * household profile (no solar panels), €/kWh excl. VAT. Unrounded.
   */
  electricity: number;
  /** Upstream calculation timestamp, "YYYY-MM-DD HH:mm:ss" (Europe/Amsterdam). */
  lastUpdated: string | null;
}

// Snapshot of the VvDE response of 2026-09-24 (inclVat=0), used in dev.
export const MOCK_EXPECTED_PRICES: ExpectedPrices = {
  electricity: 0.14668077389,
  lastUpdated: "2026-09-24 15:38:15",
};

const useMockInDev = import.meta.env.VITE_USE_MOCK_PRICES !== "false";

export async function fetchExpectedPrices(): Promise<ExpectedPrices> {
  if (import.meta.env.DEV && useMockInDev) {
    return MOCK_EXPECTED_PRICES;
  }

  const response = await fetch("/api/expected-prices");
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  const payload = (await response.json()) as Partial<ExpectedPrices>;
  if (
    typeof payload.electricity !== "number" ||
    !Number.isFinite(payload.electricity)
  ) {
    throw new Error("API response missing expected electricity price");
  }
  return {
    electricity: payload.electricity,
    lastUpdated: payload.lastUpdated ?? null,
  };
}
